var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as Components from '_components';
import * as Common from '_common';
export function ServerTagList(props) {
    var tagsData = useTags()[0];
    return Common.renderServerData(tagsData, function (tags) { return _jsx(TagList, __assign({ tags: tags }, props)); });
}
export function TagList(props) {
    var _a;
    var selectedTagIds = ((_a = props.selectedTags) === null || _a === void 0 ? void 0 : _a.map(Common.TagId)) || [];
    var selectedTagsParsedIds = selectedTagIds.map(Common.parseTagId);
    var tagsParsedIds = props.tags.map(function (t) { return Common.parseTagId(Common.TagId(t)); });
    function renderButton(tag) {
        if (props.useLink) {
            return (_jsx(Components.ButtonLink, { to: props.linkUrl ? props.linkUrl(tag) : '', isActive: selectedTagIds.includes(Common.TagId(tag)), children: _jsx("span", { children: _jsx(Components.MLT, { text: Common.TagName(tag, props.tagInfos || []) }) }) }, Common.TagId(tag)));
        }
        return (_jsx(Components.Button, { isActive: selectedTagIds.includes(Common.TagId(tag)), onClick: function () { return props.onClick && props.onClick(Common.TagId(tag)); }, children: _jsx("span", { children: _jsx(Components.MLT, { text: Common.TagName(tag, props.tagInfos || []) }) }) }, Common.TagId(tag)));
    }
    function renderTags(tags) {
        return (_jsx(Components.BtnGroup, { type: Components.BtnGroupType.Horizontal, children: Common.sortTags(tagsParsedIds)
                .filter(function (tagId) { return Common.displayInList(tagId, selectedTagsParsedIds); })
                .map(renderButton) }));
    }
    return renderTags(props.tags);
}
function useTags() {
    var tagsData = Common.useServerData('/api/blog/tags');
    return [tagsData];
}
